import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../content";
import { Reveal, Eyebrow } from "./Reveal";

export const FaqSection = ({ items = FAQS, heading = "Frequently Asked Questions", schema = false }) => (
  <section data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-24 lg:py-32">
    <Reveal className="text-center">
      <div className="flex justify-center"><Eyebrow>Good To Know</Eyebrow></div>
      <h2 className="font-display text-3xl font-black text-brand-ink sm:text-4xl">{heading}</h2>
    </Reveal>
    <Reveal delay={0.15}>
      <Accordion type="single" collapsible className="mt-12 space-y-3">
        {items.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="rounded-2xl border border-slate-200 bg-white px-6 shadow-sm data-[state=open]:border-teal-300"
          >
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-display text-base font-bold text-brand-ink hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);

export const faqSchema = (items = FAQS) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
